import React from 'react';
import PropTypes from 'prop-types';
import Markdown from "../markdown";
import { RawHTMLSectionContainer } from "./styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
var RawHTMLSection = function RawHTMLSection(_ref) {
  var content = _ref.content,
    color = _ref.color;
  var html = content.html,
    isMarkdown = content.isMarkdown;

  /* eslint-disable react/no-danger */
  return /*#__PURE__*/_jsx(RawHTMLSectionContainer, {
    color: color,
    children: isMarkdown ? /*#__PURE__*/_jsx(Markdown, {
      children: html
    }) : /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: html
      }
    })
  });
  /* eslint-enable react/no-danger */
};

export var RAW_HTML_PROP_TYPES = {
  content: PropTypes.shape({
    html: PropTypes.string.isRequired,
    isMarkdown: PropTypes.bool
  }).isRequired,
  color: PropTypes.string.isRequired
};
RawHTMLSection.propTypes = RAW_HTML_PROP_TYPES;
RawHTMLSection.displayName = RawHTMLSection;
export default /*#__PURE__*/React.memo(RawHTMLSection);